import { render, staticRenderFns } from "./addorgpoint.vue?vue&type=template&id=673cab84&scoped=true"
import script from "./addorgpoint.vue?vue&type=script&lang=js"
export * from "./addorgpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673cab84",
  null
  
)

export default component.exports